<template>
  <div class="moving-arrow" :style="arrowStyle">
  </div>
</template>
<script>
export default {
  props: {
    moveY: {
      type: Number,
      default: 0
    }
  },
  computed: {
    /**
     * Styles to animate the arrow
     * @returns {{transform: string}}
     */
    arrowStyle() {
      return {
        transform: `translate3d(0px, ${this.moveY}px, 0px)`
      };
    }
  }
};
</script>
<style lang="scss">
$bg-nude: #f2f2f2 !default;

$success-color: #87F599;

.moving-arrow {
  // border-radius: 130px;
  // border-right: 5px solid $success-color;
  // border-top: 5px solid $success-color;
  // border-bottom: 2px solid $success-color;
  // display: inline-block;
  // position: absolute;
  // left: 250px;
  // top: 110px;
  // transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1);
}
@media (max-width: 1201px) {
  .moving-arrow {
    display: none;
  }
}
</style>
